import { getTotalForestArea, isAreaInRange } from "./utils";

const calculateDiscountAmount = (couponDiscount) =>
  couponDiscount?.coupon_discount_price || 0;

export const calculatePrices = ({
  properties,
  couponDiscount,
  subscriptionPrices,
}) => {
  const hasErrors = properties.some((prop) => prop.plus_price_error);

  if (hasErrors) {
    return {
      totalForestArea: 0,
      propertiesTotalPrice: 0,
      discountAmount: 0,
      discountedPrice: 0,
      propertiesHectarePrice: 0,
    };
  }
  const totalForestArea = getTotalForestArea(properties);

  if (!subscriptionPrices?.products || !properties?.length) {
    return {
      totalForestArea: 0,
      propertiesTotalPrice: 0,
      discountAmount: 0,
      discountedPrice: 0,
      propertiesHectarePrice: 0,
    };
  }

  const propertiesTotalPrice = properties.reduce(
    (acum, prop) => acum + prop.plus_price,
    0
  );
  const propertiesHectarePrice = propertiesTotalPrice / totalForestArea ?? 0;

  const discountAmount = calculateDiscountAmount(couponDiscount);
  const discountedPrice = Math.max(propertiesTotalPrice - discountAmount, 0);

  return {
    totalForestArea,
    propertiesTotalPrice: propertiesTotalPrice,
    discountAmount,
    discountedPrice,
    propertiesHectarePrice,
  };
};
